import React from 'react';
import classes from  './universalBackdrap.module.css';
import successImage from '../../../Assets/Images/Successmdpi.png'
import {Button} from 'react-bootstrap';
import {connect} from 'react-redux';
import * as actionTypes from '../../../Action/Index'
import Loader from 'react-loader-advanced';
import Spinner from 'react-bootstrap/Spinner'


const VerifyEmailAfterLogin = (props) => {
    return <div className={classes.afterSuccessScreen}>
                
        <div className={classes.afterSuccessBox}>
            {
                props.resendEmailLoader ?
                <Loader show={true} message={ <Spinner animation="border" role="status"></Spinner> } style={{height:"294px", width: '100%'}}
    foregroundStyle={{color: '#fbb03b'}}
    backgroundStyle={{backgroundColor: '#F3EFEF'}}
    ></Loader>:
    <>
    <div className={classes.successImage}>
                        <img src={successImage} alt="successIcon" />
                    </div>
                    <div className={classes.successText}>
                        <span>Mobile Verification Successful!</span><br/>
                        <span>We have sent an email to {props.email}</span><br/>
                        <span>Click on verification link to activate your account.</span>
                    </div>
                    <div className={classes.button}>
                        <Button variant='warning' onClick={props.closeModal}>Ok</Button>
                    </div>
                    <div className={classes.resendText}>
                        <span>Didn't receive the email? <span onClick={() => props.resendSignUpEmail(props.email)} style={{cursor: 'pointer'}}>Resend</span></span>
                    </div>
    </>
            }
                    
                </div>
        
            </div>;
}

const mapStateToProps = state => {
    return{
      verifyEmailStatus: state.employeeReducer.verifyEmailStatus,
      resendEmailLoader: state.employeeReducer.resendEmailLoader
    }
  }
  
const mapDispatchToProps = dispatch => {
    return{
        resendSignUpEmail: (email) => dispatch(actionTypes.resendSignUpEmail(email)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifyEmailAfterLogin);